import { FunctionComponent, memo } from 'react';

import { useTranslation } from 'react-i18next';
import { useTimer } from '~components/hooks';

interface Props {
  endDate: Date;
  isLaunched: boolean;
  isEndend: boolean;
}

export const Timer: FunctionComponent<Props> = memo(({ endDate, isEndend }) => {
  const { t } = useTranslation();
  const eventTimer = useTimer(endDate);

  if (isEndend) {
    return (
      <div className="page-timer">
        <div className="page-timer-wrap">
          <div className="page-timer-close-text">
            <span className="emoji">🎉</span>
            <span className="timer-title">
              {t('event page-timer page-timer-wrap page-timer-close-text')}
            </span>
            <span className="emoji">🎉</span>
          </div>
        </div>
      </div>
    );
  }

  if (!eventTimer) {
    return null;
  }

  return (
    <div className="page-timer">
      <div className="page-timer-wrap">
        <div className="page-timer-day">
          <span>
            {eventTimer?.days} {t('d')}.
          </span>
        </div>
        <div className="page-timer-hours">{eventTimer?.hours}</div>
        <div className="page-timer-separator">:</div>
        <div className="page-timer-minutes">{eventTimer?.minutes}</div>
        <div className="page-timer-separator">:</div>
        <div className="page-timer-seconds">{eventTimer?.seconds}</div>
      </div>
    </div>
  );
});
